module.exports = __webpack_public_path__ + "Cash-and-Bank-Cards.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Cash-and-Bank-Cards.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Cash-and-Bank-Cards.png
// module chunks = 15